import "../config";
import * as API from "./URL";

export const fetchCheckAssetData = async (assetId, unit, callback) => {
  return fetch(API.getCheckAssetData(assetId, unit), {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchConsumptionDataByYear = async (params, callback) => {
  return fetch(API.getConsumptionDataByYear(params), {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchUpdateMultiConsumption = async (data, year, callback) => {
  return fetch(API.updateMultiConsumptionAPI(year), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchEmissionDataByYear = async (params, callback) => {
  return fetch(API.getEmissionDataByYear(params), {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchUpdateMultiEmission = async (data, year, callback) => {
  return fetch(API.updateMultiEmissionAPI(year), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getAssetUnits = async (unit, callback) => {
  return fetch(API.getAssetUnit(unit), {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAssetDataByUserId = async (data, callback) => {
  return fetch(API.getAssetDataByUserId, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAssetDataForUserId = async (data, callback) => {
  return fetch(API.getAssetDataForUserId, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchUpdateAssetsData = async (data, userId, callback) => {
  return fetch(API.updateAssetsData(userId), {
    method: "PUT",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchDeleteAssets = async (data, userId, callback) => {
  return fetch(API.deleteAssets(userId), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchCompanyFileList = async (companyId, callback) => {
  return fetch(API.companyFileList(companyId), {
    method: "GET",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchCompanyFileUpload = async (data, callback) => {
  return fetch(API.companyFileUpload, {
    method: "POST",
    headers: {
      // "content-Type": "application/json",
      Accept: "*/*",
      // "Access-Control-Allow-Origin": "*",
    },
    body: data,
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchCheckUploadedFile = async (id, fileName, callback) => {
  return fetch(API.checkUploadFile(id, fileName), {
    method: "Get",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchDeleteUploadedFile = async (id, fileName, callback) => {
  return fetch(API.forceDeleteUploadFile(id, fileName), {
    method: "DELETE",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAssignAssets = async (bodyData, callback) => {
  return fetch(API.assignAssets, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      // "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(bodyData),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAssetUsers = async (id, role, callback) => {
  return fetch(API.getViewListsByCompany(id, role), {
    method: "GET",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAssetUser = async (id, role, callback) => {
  return fetch(API.getUser(id, role), {
    method: "GET",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAddConsumptionDataByYear = async (
  data,
  year,
  companyId,
  callback
) => {
  return fetch(API.addConsumptionDataByYear(year, companyId), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAddConsumptionDataByYearWithExcel = async (
  data,
  year,
  userId,
  callback
) => {
  return fetch(API.addConsumptionDataByYearWithExcel(year, userId), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const addDataEntryByYearWithExcel = async (
  data,
  year,
  companyId,
  callback
) => {
  return fetch(API.addDataEntryByYearWithExcel(year, companyId), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const addDataEntryByYear = async (data, year, companyId, callback) => {
  return fetch(API.addDataEntryByYear(year, companyId), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const addEmissionActivity = async (params, data, callback) => {
  return fetch(API.createEmissionActivity(params), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getRefreshScheduleData = async (value, callback) => {
  return fetch(API.getScheduleData(), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(value),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchScheduleCompanyId = async (data, callback) => {
  return fetch(API.getScheduleCompanyIdData(data), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getExcelEmissionActivityUsingPython = async (data) => {
  try {
    const response = await fetch(
      API.getExcelEmissionActivityUsingPython(data),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching the Excel file:", err);
    throw err;
  }
};

export const uploadEmissionActivityFileUsingPython = async (
  file,
  cId,
  dialog,
  language,
  callback
) => {
  const formData = new FormData();
  formData.append("file", file);
  return fetch(API.uploadEAFileUsingPython(cId, dialog, language), {
    method: "POST",
    headers: {
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchUpdateConsumptionDataByYear = async (
  data,
  year,
  companyId,
  callback
) => {
  return fetch(API.updateConsumptionDataByYear(year, companyId), {
    method: "PUT",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchDeleteConsumptionDataByYear = async (
  data,
  year,
  companyId,
  callback
) => {
  return fetch(API.deleteConsumptionDataByYear(year, companyId), {
    method: "PUT",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchConsumptionData = async (year, userId, callback) => {
  return fetch(API.getConsumptionData(year, userId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchEmissionData = async (year, userId, callback) => {
  return fetch(API.getEmissionData(year, userId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchY2yAssetScopeEmissions = async (
  scope,
  year,
  companyId,
  monthIndex,
  callback
) => {
  return fetch(
    API.getY2yAssetScopeEmissions(scope, year, companyId, monthIndex),
    {
      method: "GET",
      headers: {
        "content-Type": "application/json",
        Accept: "*/*",
        "Access-Control-Allow-Origin": "*",
      },
    }
  )
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchY2yAssetEnergy = async (callback) => {
  return fetch(API.getY2yAssetEnergy, {
    method: "GET",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchY2yAssetWater = async (callback) => {
  return fetch(API.getY2yAssetWater, {
    method: "GET",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getLinkedFile = async (linkedFileId, callback) => {
  return fetch(API.getAssetLinkedFile(linkedFileId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      responseType: "blob",
    },
  })
    .then((res) => callback(null, res))
    .catch((err) => callback(err.toString(), null));
};

export const fetchFile = async (bodyData, callback) => {
  return fetch(API.fetchEmissionCalcuToolFile, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      responseType: "blob",
    },
    body: JSON.stringify({ bodyData }),
  })
    .then((res) => callback(null, res))
    .catch((err) => callback(err.toString(), null));
};

export const fetchPCFFile = async (bodyData, callback) => {
  return fetch(API.fetchPCFFileDownload, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      responseType: "blob",
    },
    body: JSON.stringify({ bodyData }),
  })
    .then((res) => callback(null, res))
    .catch((err) => callback(err.toString(), null));
};
// export const postCustomEmission = async (bodyData, callback) => {
//   return fetch(API.addCustomEmission, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "*/*",
//       "Access-Control-Allow-Origin": "*",
//     },
//     body: JSON.stringify(bodyData),
//   })
//     .then((res) => res.json())
//     .then((data) => callback(null, data))
//     .catch((err) => callback(err.toString(), null));
// };

export const changeVerifyStatus = async (bodyData, callback) => {
  return fetch(API.addVerifyStatus, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(bodyData),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getCustomEmissionFactorList = async (callback) => {
  return fetch(API.getCustomEmissionFactorList, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getCustomEmissionFactorCount = async (callback) => {
  return fetch(API.getCustomEmissionFactorCount, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getAllChildCompanyCount = async (callback) => {
  return fetch(API.getAllChildCompanyCount, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getExpiryUserCount = async (callback) => {
  return fetch(API.getExpiryUserCount, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getAllChildCompanyList = async (callback) => {
  return fetch(API.getAllChildCompanyList, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getAllFacilityCompanyList = async (callback) => {
  return fetch(API.getAllFacilityCompanyList, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getAllUserOperator = async (callback) => {
  return fetch(API.getAllUserOperator, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAddEmissionDataByYear = async (
  data,
  year,
  companyId,
  callback
) => {
  return fetch(API.addEmissionDataByYear(year, companyId), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchDeleteEmissionDataByYear = async (
  data,
  year,
  companyId,
  callback
) => {
  return fetch(API.deleteEmissionDataByYear(year, companyId), {
    method: "PUT",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const DeleteCustomEmissionFactorList = async (
  customCalID,
  id,
  companyID,
  callback
) => {
  return fetch(API.deleteCustomEmissionFactorList(customCalID, id, companyID), {
    method: "PUT",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    // body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const fetchAssetList = async (callback) => {
  return fetch(API.getAssetList, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getCalApproachesList = async (
  page,
  rowPerPage,
  selectedSource,
  selectedYear,
  selectedScope,
  selectedCategory,
  searchQuery,
  callback
) => {
  console.log("APIIIII", page, rowPerPage);
  return fetch(
    API.getCalApproachesList(
      page,
      rowPerPage,
      selectedSource,
      selectedYear,
      selectedScope,
      selectedCategory,
      searchQuery
    ),
    {
      method: "GET",
      headers: {
        "content-Type": "application/json",
        Accept: "*/*",
        "Access-Control-Allow-Origin": "*",
      },
      // body: JSON.stringify(data),
    }
  )
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const getGWPList = async () => {
  try {
    const response = await fetch("https://rd.evercomm.com.sg/api/get_GWP", {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); // 將結果轉為 JSON 格式
    console.log("資料:", JSON.stringify(data));
    return data;
    // 在這裡處理資料，例如更新 UI
  } catch (error) {
    console.error("取得資料時出錯:", error);
    // 在這裡添加更多的錯誤處理邏輯
  }
};

export const getDbInventoryList = async (callback) => {
  return fetch(API.getDbInventory(), {
    method: "GET",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    // body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const downloadDefaultTemplate = async (file, callback) => {
  return fetch(API.downloadDefaultTemplate(file?.value), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      responseType: "blob",
    },
    // body: JSON.stringify(data),
  })
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const uploadEmissionFactorFile = async (data, callback) => {
  return fetch(API.uploadEmissionFactorFile(), {
    method: "POST",
    headers: {
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};

export const uploadCustomEFFileUsingPython = async (file, cId, callback) => {
  const formData = new FormData();
  formData.append("file", file);
  return fetch(API.uploadCustomEFFileUsingPython(cId), {
    method: "POST",
    headers: {
      // "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    },
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => callback(null, data))
    .catch((err) => callback(err, null));
};

export const getCustomEFUsingPython = async (cId, callback) => {
  return fetch(API.downloadCustomEFUsingPython(cId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      responseType: "blob",
    },
  })
    .then((data) => callback(null, data))
    .catch((err) => callback(err.toString(), null));
};
